export const company = (state) => state.empresa;
export const companyId = (state) => state.empresa.id;

// TODO: remove alias.
export const empresa = company;
// TODO: remove alias.
export const empresaActual = company;
// TODO: remove alias.
export const defaultEmpresa = company;

export const iut = (state) => state.empresa.iut;

export const companies = (state) => state.empresas;

export const userSignConfiguration = (state) => ({
  userSigns: state.userSigns,
  advancedSign: state.advancedSign,
  simpleSign: state.simpleSign
});

export const usersCompany = (state) => (state.usersCompany || []).sort(
  ({ nombre: a }, { nombre: b }) => a.localeCompare(b)
);
export const usersCompanyAssign = (state) => (state.usersCompanyAssign || []).sort(
  ({ nombre: a }, { nombre: b }) => a.localeCompare(b)
);
export const groupsCompany = (state) => (state.groupsCompany || []).sort(
  ({ nombre: a }, { nombre: b }) => a.localeCompare(b)
).map((group) => ({
  ...group,
  isDivision: group.esDivision === 'Y',
  isOffice: group.esOficina === 'Y',
  isOpen: true
}));

export const firstGroupsCompany = (state) => (state.groupsCompany || []).filter(
  (group) => !group.padreId
).map((group) => ({
  ...group,
  isDivision: group.esDivision === 'Y',
  isOffice: group.esOficina === 'Y',
  isOpen: true
}));
export const pagination = (state) => state.pagination;
export const usersByGroup = (state) => state.usersGroup;
export const loading = (state) => state.loading;

export const configurations = (state) => state.configurations;
export const isLoadingConfigurations = (state) => state.isLoadingConfigurations;
export const isSavingConfigurations = (state) => state.isSavingConfigurations;
export const successAction = (state) => state.successAction;
export const substitutes = (state) => state.substitutes.filter(
  (user) => user.estado.toString() !== '100'
);

export const lists = (state) => state.list;

export const settingsLoading = (state) => state.settingsLoading;
export const settings = (state) => state.settings;
